import * as React from 'react';

export function IconWarning() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FF5050"
          //tslint:disable-next-line:max-line-length
          d="M1.822 11.922a.825.825 0 0 1-.71-1.237L6.254 1.73a.819.819 0 0 1 1.42 0l5.144 8.955a.825.825 0 0 1-.71 1.237H1.822z"
        />
        <path
          fill="#FFF"
          //tslint:disable-next-line:max-line-length
          d="M7.858 10.257c0 .496-.4.897-.893.897a.895.895 0 0 1-.892-.897c0-.495.4-.898.892-.898.494 0 .893.403.893.898M6.965 4.669a.895.895 0 0 0-.892.897c0 .495.269 3.564.762 3.564h.26c.494 0 .763-3.069.763-3.564 0-.496-.4-.897-.893-.897"
        />
      </g>
    </svg>
  );
}
